/* eslint-disable no-template-curly-in-string */
export const environment: {
  [key: string]: string;
} = {
  BASE_NAME: '${B21_BASE_NAME}',
  BASE_APP_URL: '${B21_BASE_APP_URL}',
  ENV: '${ENV}',
  API_URL: '${B21_API_URL}',
  AUDIENCE: '${B21_AUDIENCE}',
  ULA_URL: '${B21_ULA_URL}',
  ONBOARDING_URL: '${B21_ONBOARDING_URL}',
  UPLOAD_PRESET_DIRECTORY: '${B21_UPLOAD_PRESET_DIRECTORY}',
  CN_HOT_CLOUDNAME: '${B21_CN_HOT_CLOUDNAME}',
  CN_COLD_CLOUDNAME: '${B21_CN_COLD_CLOUDNAME}',
  UPLOAD_PRESET_VIDEO: '${B21_CN_HOT_UPLOAD_PRESET_VIDEO}',
  UPLOAD_PRESET_AUDIO: '${B21_CN_HOT_UPLOAD_PRESET_AUDIO}',
  UPLOAD_PRESET_DEFAULT: '${B21_CN_HOT_UPLOAD_PRESET}',
  UPLOAD_AUTHENTICATED_PRESET: '${B21_CN_HOT_UPLOAD_AUTHENTICATED_PRESET}',
  CLD_DOMAIN: '${B21_CLD_DOMAIN}',
  RECURLY_PUBLIC_KEY: '${B21_RECURLY_PUBLIC_KEY}',
  TALENT_PROFILE_PUBLIC_LINK: '${B21_TALENT_PROFILE_PUBLIC_LINK}',
  LAUNCH_DARKLY_CLIENT_ID: '${B21_LAUNCH_DARKLY_ID}',
  GOOGLE_AUTH_CLIENT_ID: '${B21_GOOGLE_AUTH_CLIENT_ID}',
  GOOGLE_MAPS_API_KEY: '${B21_GOOGLE_MAPS_API_KEY}',
  GOOGLE_TAG_MANAGER_ID: '${B21_GOOGLE_TAG_MANAGER_ID}',
  GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH: '${B21_GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH}',
  GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW: '${B21_GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW}',
  SENTRY_DSN: '${B21_SENTRY_DSN}',
  B21_RELEASE: '${B21_RELEASE}',
  ALLOWED_COUNTRIES: '${B21_ALLOWED_COUNTRIES}',
  BRAZE_API_KEY: '${B21_BRAZE_API_KEY}',
  BRAZE_API_ENDPOINT: '${B21_BRAZE_API_ENDPOINT}',
  FEATURE_TALENT_FORCE_PERSONAL_PROFILE: '${B21_FEATURE_TALENT_FORCE_PERSONAL_PROFILE}',
  TEXT_MESSAGING_COUNTRIES: '${B21_TEXT_MESSAGING_COUNTRIES}',
  AG_GRID_LICENSE: '${B21_AG_GRID_LICENSE}',
  CDN_URL: '${B21_CDN_URL}',
  SURVEY_JS_LICENSE: '${B21_SURVEY_JS_LICENSE}',
  CLOUDFLARE_TURNSTILE_SITE_KEY: '${CLOUDFLARE_TURNSTILE_SITE_KEY}',
  INSTAGRAM_CLIENT_ID: '${B21_INSTAGRAM_CLIENT_ID}',
  TIKTOK_CLIENT_KEY: '${B21_TIKTOK_CLIENT_KEY}',
  HOTJAR_SITE_ID: '${B21_HOTJAR_SITE_ID}',
  IOS_APP_ID: '${B21_IOS_APP_ID}',
  FRONT_CHAT_ID: '${B21_FRONT_CHAT_ID}',
  CLD_MEDIA_DOMAIN: '${B21_CLD_MEDIA_DOMAIN}',
};
